import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-block-item",
  templateUrl: "./block-item.component.html",
})
export class BlockItemComponent {
  @Input() block: any;
  @Output() nextClick: EventEmitter<any> = new EventEmitter();

  handleNext() {
    this.nextClick.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/block-item/block-item.component.ts